(() => {
  const preferredOrder = [
    'shop',
    'occasions',
    'holidays',
    'corporate-gifts',
    'custom-logo-cookies',
    'back-to-school',
    'last-minute-gifts',
    'store-locator',
    'help'
  ];

  const handleize = (value = '') => value
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const reorder = (nav) => {
    if (!nav) return;
    const items = Array.from(nav.children).filter((item) => item.tagName === 'LI');
    const scored = items.map((item, originalIndex) => {
      const link = item.querySelector(':scope > a');
      const handle = handleize(link?.textContent || '');
      const orderIndex = preferredOrder.indexOf(handle);
      return { item, originalIndex, orderIndex: orderIndex === -1 ? 999 + originalIndex : orderIndex };
    });
    scored.sort((a, b) => a.orderIndex - b.orderIndex || a.originalIndex - b.originalIndex);
    scored.forEach(({ item }) => nav.appendChild(item));
  };

  const init = () => {
    reorder(document.querySelector('#siteNav'));
    reorder(document.querySelector('#MobileNav'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
